<template>
  <div class="mb-7">
    <slot />
  </div>
</template>